export default {
  computed: {
    userData: function () {
      return this.$store.getters['auth/user']
    }
  },
  methods: {
    getJobs () {
      this.$store.dispatch('reposession/getJobData', this.userData)
    }
  }
}
